import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 14px 16px;
  border: 1px solid ${colors.gray220};
  border-radius: 8px;
  background: #fff;
`

export const Top = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap; /* in a narrow container the date wraps onto its own line */
  gap: 6px 10px;
`

export const Name = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: ${colors.black700};
  white-space: nowrap;
`

export const Chip = styled.span<{ $synced: boolean }>`
  flex: none;
  padding: 3px 10px;
  border-radius: 25px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  color: ${({ $synced }) => ($synced ? colors.green800 : colors.gray450)};
  background: ${({ $synced }) => ($synced ? colors.green100 : colors.gray200)};
`

export const Time = styled.span`
  margin-left: auto; /* pushes the date to the right edge */
  font-size: 13px;
  color: ${colors.gray450};
  white-space: nowrap;
`

export const ExternalId = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: ui-monospace, 'SF Mono', Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  color: ${colors.gray900};
`

export const ExternalIdRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`

export const CopyButton = styled.button`
  flex: none;
  display: flex;
  align-items: center;
  padding: 2px;
  border: none;
  border-radius: 4px;
  background: none;
  color: ${colors.gray450};
  cursor: pointer;

  &:hover {
    background: ${colors.gray200};
  }

  svg {
    font-size: 14px;
  }
`
